import { render, staticRenderFns } from "./VSpinner.vue?vue&type=template&id=8c374280&scoped=true"
import script from "./VSpinner.vue?vue&type=script&lang=ts"
export * from "./VSpinner.vue?vue&type=script&lang=ts"
import style0 from "./VSpinner.vue?vue&type=style&index=0&id=8c374280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c374280",
  null
  
)

export default component.exports